export const INGREDIENT_SERVING_STATES = Object.freeze({
	HOT: "HOT",
	COLD: "COLD",
});

export const INGREDIENT_SERVING_STATE_NAME_MAP = Object.freeze({
    [INGREDIENT_SERVING_STATES.HOT] : "Hot",
    [INGREDIENT_SERVING_STATES.COLD] : "Cold"
});

const INGREDIENT_SERVING_TEMPERATURE_THRESHOLD = 60;

export function getIngredientServingState(servingTemperature) {
    if(servingTemperature > INGREDIENT_SERVING_TEMPERATURE_THRESHOLD) {
        return INGREDIENT_SERVING_STATES.HOT;
    }
    return INGREDIENT_SERVING_STATES.COLD;
}